<template>
  <div>
    <div class="container">
      <section id="filter">
        <div class="row mt-2">
          <div class="col-3">
            <input
              placeholder="Tgl. Upload"
              class="form-control m-2"
              :type="typeTglUpload"
              @focus="typeTglUpload = 'date'"
              @blur="filter.tglUpload == '' ? (typeTglUpload = 'text') : (typeTglUpload = 'date')"
              id="date"
              v-model="filter.tglUpload"
            />
          </div>
          <div class="col-3">
            <select class="form-select m-2" v-model="filter.client" :class="filter.client ? '' : 'text-secondary'">
              <option value="" selected>
                {{ filter.client ? "none" : "Client" }}
              </option>
              <option v-for="(option, index) in dataClient" :key="index" class="text-dark" :value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="col-3">
            <input placeholder="Batch" class="form-control m-2" type="text" list="batch" v-model="filter.batch" @keyup="getDataBatch($event)" />
            <datalist id="batch">
              <option v-for="(batch, index) in dataBatch" :key="index">
                {{ batch.batch }}
              </option>
            </datalist>
          </div>
          <div class="col-3">
            <button @click="getDataRiwayat('0')" class="btn btn-success rounded-pill shadow text-white mx-2">
              <i class="fa fa-search"></i>
            </button>
            <button @click="refresh()" class="btn btn-success rounded-pill shadow text-white mx-2">
              <i class="fa fa-refresh"></i>
            </button>
          </div>
        </div>
      </section>
      <section id="table" class="p-2 mt-2">
        <tabel-riwayat-upload
          :data-table="dataTable"
          :data-length="dataLength"
          :page-length="pageLength"
          :offset="pageOffset"
          :size="pageSize"
          :current-page="currentPage"
          @afterdone="getDataRiwayat('0')"
          @changeShowMode="handleModeChange"
        >
          <template #button>
            <paginate
              v-model="pagination"
              :page-count="pageLength"
              :page-range="5"
              :margin-pages="1"
              :click-handler="movePage"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :first-last-button="true"
              first-button-text="<<"
              last-button-text=">>"
            />
          </template>
        </tabel-riwayat-upload>
      </section>
    </div>
  </div>
</template>

<script setup>
import TabelRiwayatUpload from "../../components/riwayat/TabelRiwayatUpload.vue";
import Paginate from "vuejs-paginate-next";
import { ref } from "@vue/reactivity";
import { computed, onMounted } from "@vue/runtime-core";
import { ApiService } from "@/axios/apiService";
import { useStore } from "vuex";

//data
const store = useStore();
const pagination = computed(() => currentPage.value + 1);
const apiService = new ApiService();
const currentMode = ref("active");
const filter = ref({
  tglUpload: "",
  client: "",
  batch: "",
});
const dataClient = ref([]);
const dataBatch = ref([]);
const dataTable = ref([]);
const dataLength = ref(0);
const currentPage = ref(0);
let pageSize = ref(10);
const pageLength = computed(() => Math.ceil(dataLength.value / pageSize.value) || 1);
const pageOffset = computed(() => {
  if (dataLength.value < 1) {
    return 0;
  }
  return 10 * currentPage.value + 1;
});
const typeTglUpload = ref("text");

//method
onMounted(async () => {
  const resClient = await apiService.getPelanggan(10, 0);
  dataClient.value = resClient.data.content;
  await getDataRiwayat("0");
});

const refresh = async () => {
  filter.value = {
    tglUpload: "",
    client: "",
    batch: "",
  };

  typeTglUpload.value = "text";
  await getDataRiwayat("0");
};

let timeoutIdBatch;
const getDataBatch = async (e) => {
  try {
    if (timeoutIdBatch) {
      clearTimeout(timeoutIdBatch);
    }
    const data = filter.value.batch;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdBatch = setTimeout(async () => {
        const res = await apiService.getBatch(data);
        dataBatch.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

const getShowDeleted = (mode) => {
  if (mode === "deleted") return "true";
  if (mode === "active") return "false";
  return "";
};

const getDataRiwayat = async (pageNumber) => {
  try {
    store.state.isLoading = true;
    filterMove = { 
      ...filter.value, 
      showDeleted: getShowDeleted(currentMode.value) 
    };
    const res = await apiService.getRiwayatUpload(10, pageNumber, filterMove);
    dataTable.value = res.data.content || [];
    dataLength.value = res.data.totalElements || 0;
    currentPage.value = Number(pageNumber);
    pageSize.value = res.data.size || 10;
    store.state.isLoading = false;
  } catch (error) {
    store.state.isLoading = false;
    console.log(error);
  }
};

const handleModeChange = async (mode) => {
  currentMode.value = mode;
  await getDataRiwayat("0");
};

let filterMove;
const movePage = async (pageNumber) => {
  store.state.isLoading = true;
  currentPage.value = Number(pageNumber) - 1;
  const res = await apiService.getRiwayatUpload(10, currentPage.value, filterMove);
  dataTable.value = res.data.content || [];
  dataLength.value = res.data.totalElements || 0;
  pageSize.value = res.data.size || 10;
  store.state.isLoading = false;
};
</script>
